import { ConfigsService, WindowProxy } from '@sm360/widget-commons-core-services';
import { ModalService, AccountService, AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import { LeadSubmissionBuilder, LEAD_TYPES } from '@sm360/widget-commons-leads';

import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

import VehicleService from 'commons-vehicle/Vehicle/services/VehicleService/VehicleService.js';
import { BAD_QUOTE_REVISION } from 'build-and-quote/constants/errorCodes.js';

// SHOWROOM V2.5
class AddToGarageV25 {
    constructor() {
        this.quote = null;

        this.onClick = this.onClick.bind(this);
        this.loadQuote = this.loadQuote.bind(this);
        this.addToGarageLeadUpdate = this.addToGarageLeadUpdate.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.setQuoteLead = this.setQuoteLead.bind(this);
        this.isQuoteInGarage = this.isQuoteInGarage.bind(this);
        this.LoginModal = ModalService.get('login/SignUpModal');
        this.LoginModal.addCallbacks({
            onClose: this.saveToGarage,
        });
    }

    onClick(quoteId) {
        if (!quoteId) return;

        ShowroomService.loadQuoteV25(quoteId)
            .then((quote) => {
                this.quote = quote;

                const mappingQuote = quote;

                if (mappingQuote.vehicle) {
                    AnalyticsService.gaTrigger(
                        VehicleService.isVehicleNew(mappingQuote.vehicle)
                            ? TAGS.ADD_TO_GARAGE_CTA_NEW(mappingQuote.vehicle.model)
                            : TAGS.ADD_TO_GARAGE_CTA_USED(mappingQuote.vehicle.model)
                    );
                }

                if (!AccountService.isAuthenticated()) {
                    this.LoginModal.open({ mappingQuote });
                } else {
                    this.saveToGarage(false);
                }
            })
            .catch((error) => {
                throw error;
            });
    }

    setQuoteLead(leadType) {
        const location = ConfigsService.getOrganizationUnitLocation().toLowerCase();

        const mappingQuote = QuoteService.resetQuoteFromVehicle(this.quote, location, leadType, this.quote.vehicle);

        if (AccountService.isAuthenticated()) {
            return ShowroomService.saveQuote(mappingQuote.getShowroomQuote())
                .then((showroomQuote) => {
                    const mappedQuote = QuoteService.resetQuoteFromShowroomSave(mappingQuote, showroomQuote);

                    this.quote = mappedQuote;

                    this.dispatchAddToGarage();

                    // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
                    setTimeout(() => {
                        new LeadSubmissionBuilder()
                            .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
                            .addQuote(mappedQuote)
                            .submit();

                        this.dispatchVdp(mappedQuote.id);
                    }, 2000);
                })
                .catch((error) => {
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.error === BAD_QUOTE_REVISION
                    ) {
                        this.reloadAndSaveQuote(this.quote);
                    } else {
                        throw error;
                    }
                });
        }
        return true;
    }

    loadQuote(quoteId) {
        if (this.quote === null) {
            return ShowroomService.loadQuoteV25(quoteId)
                .then((quote) => {
                    this.quote = quote;
                })
                .catch((error) => {
                    throw error;
                });
        }
        return null;
    }

    dispatchAddToGarage() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.document.dispatchEvent(new Event('sm360.widgets.garage.added'));
        }
    }

    dispatchVdp(quoteId) {
        const $window = WindowProxy.get();
        const event = new CustomEvent('add-to-garage:success', {
            bubbles: true,
            cancelable: false,
            detail: { quoteId },
        });

        if ($window) {
            $window.document.dispatchEvent(event);
            window.location.href = this.quote.getVehicleRedirectionFromQuote();
        }
    }

    reloadAndSaveQuote(quote) {
        ShowroomService.loadQuote(quote.id).then((upToDateQuote) => {
            const mergedQuote = quote.set('leadId', upToDateQuote.leadId).set('revision', upToDateQuote.revision);

            return ShowroomService.saveQuote(mergedQuote.getShowroomQuote()).then((showroomQuote) => {
                this.dispatchAddToGarage();
                this.quote = showroomQuote;
            });
        });
    }

    addToGarageLeadUpdate(quote) {
        // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
        return new LeadSubmissionBuilder()
            .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
            .addQuote(quote)
            .submit();
    }

    saveToGarage(withAuthentication = true) {
        const mappingQuote = this.quote;

        if (AccountService.isAuthenticated()) {
            if (!withAuthentication && mappingQuote.vehicle && !VehicleService.isVehicleNew(mappingQuote.vehicle)) {
                this.addToGarageLeadUpdate(mappingQuote);
            }
            this.setQuoteLead('SAVE_TO_GARAGE');
        }
        return true;
    }

    isQuoteInGarage(quoteId) {
        let response = false;
        if (!AccountService.isAuthenticated()) return false;
        return ShowroomService.loadQuotes().then((res) => {
            if (res) {
                res.forEach((e) => {
                    if (e.id === quoteId) response = true;
                });
            }
            return response;
        });
    }
}

export default AddToGarageV25;



// WEBPACK FOOTER //
// ./src/Quote/components/AddToGarageV25/AddToGarageV25.jsx